import { render, staticRenderFns } from "./TrabajadorDetalle.vue?vue&type=template&id=4ba05ada&"
import script from "./TrabajadorDetalle.vue?vue&type=script&lang=js&"
export * from "./TrabajadorDetalle.vue?vue&type=script&lang=js&"
import style0 from "./TrabajadorDetalle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports